export const API_VERSION = "v1.0";
export const GLOBAL_FETCH_TIMEOUT = 60000; // Increased to 60 seconds

// Roles
export const ADMIN = "admin";

export const ACCESS_TOKEN = "access_token";
export const TEMPORARY_TOKEN = "temp_token";
export const REFRESH_TOKEN = "refresh_token";
export const ROLES = "roles";

export const APP_CUSTOM_ERROR = "Oops! Something went wrong, try again later.";

export const MONTHS: { [key: number]: string } = {
  0: "JAN",
  1: "FEB",
  2: "MAR",
  3: "APR",
  4: "MAY",
  5: "JUNE",
  6: "JULY",
  7: "AUG",
  8: "SEPT",
  9: "OCT",
  10: "NOV",
  11: "DEC",
};

export const JOB_TYPES = ["Full Time", "Part Time", "Freelance"];

export const WORK_MODES = ["Office", "WFH", "Hybrid", "Remote"];

export const COMPANY_CULTURE = [
  {
    key: "Horizontal Corporate Culture",
    description:
      "Teammates discuss new product ideas in the break room Everybody does a little bit of everything The CEO makes his or her own coffee You still have to prove your product's worth to critics",
  },
  {
    key: "Horizontal Corporate Culture 1",
    description:
      "Teammates discuss new product ideas in the break room Everybody does a little bit of everything The CEO makes his or her own coffee You still have to prove your product's worth to critics",
  },
  {
    key: "Horizontal Corporate Culture 2",
    description:
      "Teammates discuss new product ideas in the break room Everybody does a little bit of everything The CEO makes his or her own coffee You still have to prove your product's worth to critics",
  },
  {
    key: "Horizontal Corporate Culture 3",
    description:
      "Teammates discuss new product ideas in the break room Everybody does a little bit of everything The CEO makes his or her own coffee You still have to prove your product's worth to critics",
  },
];

export const STATUS = {
  INACTIVE: "INACTIVE",
  ACTIVE: "ACTIVE",
};
export const COMPANY_SIZE = ["< 25 Employees", "> 25 Employees", "< 50 Employees", "> 100 Employees"];

export const JOB_ACTIONS = {
  SKIP: "SKIP",
  SHORTLIST: "SHORTLIST",
  APPLIED: "APPLIED",
};

/** Shown when the user tries to apply but dob/gender/languages/city are incomplete */
export const MISSING_DEMOGRAPHICS_APPLY_MESSAGE =
  "Your demographic information is missing. Please update your profile.";

export const sectionsData = [
  {
    title: "About You",
    description: "Your interests outside of work",
  },
  {
    title: "Your Specializations & Projects",
    description: "An academic achievement that you are proud of",
  },
  {
    title: "You@work",
    description: "A work environment that you thrive in",
  },
];
